import { useCallback, useMemo, useState } from 'react';
import type { FunctionComponent, ReactNode } from 'react';

import { PopoverManagerContext } from './PopoverContext';

const PopoverManager: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  const [popovers, setPopovers] = useState<Record<string, string>>({});

  const checkActive = useCallback(
    (id: string, groupId: string): boolean => {
      return popovers[groupId] === id;
    },
    [popovers]
  );

  const setActive = useCallback((id: string, groupId: string) => {
    setPopovers(curr => {
      return { ...curr, [groupId]: id };
    });
  }, []);

  const ctx = useMemo(
    () => ({
      checkActive,
      setActive,
      popovers
    }),
    [checkActive, setActive, popovers]
  );

  return <PopoverManagerContext.Provider value={ctx}>{children}</PopoverManagerContext.Provider>;
};

export default PopoverManager;
